import React, { useEffect, useState } from "react";
import Slider from "../../shared/components/Slider";
import SkeletonLoadingSlider from "../../shared/components/SkeletonLoadingSlider";

const MoreLike = ({ animeInfo, page }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [moreLike, setMoreLike] = useState();

  useEffect(() => {
    fetchMoreLike(page);
  }, [page]);

  const fetchMoreLike = async (p) => {
    let genre = animeInfo.genres[0].mal_id;
    let genre2 = animeInfo.genres[1].mal_id;
    let genre3 = animeInfo.genres[2] ? animeInfo.genres[2].mal_id : null;

    await fetch(
      `https://api.jikan.moe/v4/anime?limit=8&page=${p}&genres=${genre},${genre2}${
        genre3 !== null ? "," + genre3 : ""
      }`
    )
      .then((res) => res.json())
      .then((data) => {
        setMoreLike(data.data);
      })
      .catch((error) => {
        setError(error);
      });
    setLoading(true);
  };
  return (
    <>
      <div>
        <h1 className="font-display text-l mt-sm">More Like This</h1>
        {!loading && !moreLike ? (
          <SkeletonLoadingSlider />
        ) : (
          <Slider animes={moreLike} />
        )}
      </div>
    </>
  );
};

export default MoreLike;
